import actions from '@modules/client-journey/store/actions'
import getters from '@modules/client-journey/store/getters'
import mutations from '@modules/client-journey/store/mutations'
import state from '@modules/client-journey/store/state'

export default { state, getters, mutations, actions }
